module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_adwords_call_cost-0d15a94cce32cf083a0cdba01e02d47f.png";